module.exports = __webpack_public_path__ + "img/big-user.375547fd.svg";